import { UIFormClient } from '../../../../../external/UIFormClient/domain/abstract/UIFormClient';
import { UserMoveFormTemplate } from '../../../domain/forms/templates/UserMoveFormTemplate';
import { IUserMoveForm } from '../../../domain/interfaces';
import { UserDomainSchemas } from '../../../index';

export class UserMoveForm extends UIFormClient<IUserMoveForm> {
  public readonly validationSchema = UserDomainSchemas.userMoveSchema;

  public properties: UIFormClient<IUserMoveForm>['properties'];

  constructor(private readonly userMoveFormTemplate: UserMoveFormTemplate) {
    super();
    this.properties = userMoveFormTemplate.compose().properties;
  }

  public static readonly compose = (
    userCreationFormTemplate: UserMoveFormTemplate,
  ): UIFormClient<IUserMoveForm> => {
    return new UserMoveForm(userCreationFormTemplate);
  };
}
